

export function getCssColors() {
    const s = typeof window !== 'undefined'
      ? getComputedStyle(document.documentElement)
      : null;
    return {
      black: s?.getPropertyValue('--official-light-black').trim()   || '#2E3B47',
      green: s?.getPropertyValue('--official-light-green').trim()  || '#7EC8C0',
      red: s?.getPropertyValue('--official-light-red').trim()  || '#E8534A',
      white: s?.getPropertyValue('--official-light-white').trim()  || '#F5F7FA',
      teal: s?.getPropertyValue('--official-light-teal').trim()  || '#5AADA5',

      salmon: s?.getPropertyValue('--salmon').trim() || '#E8534A',
      salmonLight: s?.getPropertyValue('--salmon-light').trim() || '#F07A73',
      salmonPale: s?.getPropertyValue('--salmon-pale').trim() || '#FCE8E7',
      salmonDark: s?.getPropertyValue('--salmon-dark').trim() || '#C93E36',
      calipso: s?.getPropertyValue('--calipso').trim() || '#7EC8C0',
      calipsoLight: s?.getPropertyValue('--calipso-light').trim() || '#A8DAD5',
      calipsoPale: s?.getPropertyValue('--calipso-pale').trim() || '#E6F6F5',
      calipsoDark: s?.getPropertyValue('--calipso-dark').trim() || '#5AADA5',
      marengo: s?.getPropertyValue('--marengo').trim() || '#2E3B47',
      marengoMid: s?.getPropertyValue('--marengo-mid').trim() || '#3D4F5E',
      marengoLight: s?.getPropertyValue('--marengo-light').trim() || '#5A6E7F',
      marengoPale: s?.getPropertyValue('--marengo-pale').trim() || '#EEF2F5',
      greenFinance: s?.getPropertyValue('--green').trim() || '#2A9D6E',
      greenPale: s?.getPropertyValue('--green-pale').trim() || '#E6F6EF',
      amber: s?.getPropertyValue('--amber').trim() || '#F5A623',
      amberPale: s?.getPropertyValue('--amber-pale').trim() || '#FEF3E2',
    };
  }
